"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Card = _interopRequireDefault(require("../Card"));
var _Col = _interopRequireDefault(require("../Col"));
var _Navigation = _interopRequireDefault(require("../Navigation"));
var _Row = _interopRequireDefault(require("../Row"));
var _enums = require("../../enums");
require("./LoginPageLayout.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const defaultLogo = {
  src: "https://assets.ubuntu.com/v1/82818827-CoF_white.svg",
  title: "Canonical",
  url: "/"
};
/**
 * This is a layout component that is used to display a page with a title and children.
 * The LoginPageLayout recommended usages are in the login flow like registration, sign up and error pages.
 */
const LoginPageLayout = _ref => {
  let {
    children,
    title,
    logo = defaultLogo
  } = _ref;
  (0, _react.useEffect)(() => {
    document.title = title;
  }, [title]);
  (0, _react.useLayoutEffect)(() => {
    var _document$querySelect;
    (_document$querySelect = document.querySelector("body")) === null || _document$querySelect === void 0 || _document$querySelect.classList.add("is-paper");
  });
  return /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "p-strip page-row"
  }, /*#__PURE__*/_react.default.createElement(_Col.default, {
    emptyLarge: 4,
    size: 6
  }, /*#__PURE__*/_react.default.createElement(_Card.default, {
    className: "u-no-padding page-card"
  }, /*#__PURE__*/_react.default.createElement(_Navigation.default, {
    logo: logo,
    theme: _enums.Theme.DARK
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "p-card__inner page-inner"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "p-heading--4"
  }, title), /*#__PURE__*/_react.default.createElement("div", null, children)))));
};
LoginPageLayout.propTypes = {
  title: _propTypes.default.string.isRequired,
  children: _propTypes.default.node,
  logo: _propTypes.default.shape({
    src: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    url: _propTypes.default.string.isRequired
  })
};
var _default = exports.default = LoginPageLayout;